{
  "loading": "Зареждане...",
  "placeholder": "Изберете опция"
}